/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Meta_TitleInputs */

const en_wc_on_meta_title = /** @type {(inputs: Wc_On_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft Online: Use the Free Word Alternative in Your Browser`)
};

/**
* | output |
* | --- |
* | "WordCraft Online: Use the Free Word Alternative in Your Browser" |
*
* @param {Wc_On_Meta_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_meta_title = /** @type {((inputs?: Wc_On_Meta_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Meta_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_meta_title(inputs)
});
export { wc_on_meta_title as "wc.on.meta_title" }